<div *ngIf="relationships$ | async as relationship">
    <div *ngIf="relationship.manager">
        <h2>My Manager</h2>
        <p>{{relationship.manager.fullName}} ({{relationship.manager.email}})</p>
    </div>
    <div *ngIf="relationship.directReports.length && relationship.directReports.length > 0">
        <h2>My Direct Reports</h2>
        <ul>
            @for (employee of relationship.directReports; track employee.id)
            {
            <li>{{ employee.fullName }} ({{ employee.email }})</li>
            }
        </ul>
    </div>
</div>


@if(form) {
<h2>User Profile</h2>

<form [formGroup]="form" (ngSubmit)="submit()" class="container mt-3">
    <dai-form-group for="title" label="Job Title" [controller]="form.controls['title']">
        <input #inputRef id="title" formControlName="title" />
    </dai-form-group>
    <dai-form-group for="phone" label="Phone" [controller]="form.controls['phone']">
        <input #inputRef id="phone" formControlName="phone" />
    </dai-form-group>

    <!-- Submit -->
    <div class="mt-4 row">
        <button class="col-12 col-md-2 offset-md-2 btn btn-primary" type="submit"
            [disabled]="form.invalid">Submit</button>
    </div>
</form>
}
@else {
<app-loading></app-loading>
}